import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AgentState } from './agent.state';

export const AGENT_STATE_NAME = 'agent';
const selectAgentState = createFeatureSelector<AgentState>(AGENT_STATE_NAME);
export const selectAgentCount = createSelector(
  selectAgentState,
  state => state.total
);
const selectAgentAnalytics = createSelector(
  selectAgentState,
  ({ data }) => data
);
const selectAgentAnalyticsById = (id: string) =>
  createSelector(selectAgentState, ({ data }) =>
    data.find(x => x.agent.id === id)
  );
const selectFilter = createSelector(selectAgentState, ({ filter }) => filter);
const selectRequestInfo = createSelector(
  selectAgentState,
  ({ requestInfo }) => requestInfo
);

const selectTotal = createSelector(selectAgentState, ({ total }) => total);
export default {
  selectFilter,
  selectAgentAnalytics,
  selectTotal,
  selectRequestInfo,
  selectAgentAnalyticsById,
};
